export const isPlural = (count: number) => {
	return count !== 1;
};
